import template from './ad-placing-terms.jade';
import { USE_CHECK_SERVICE, IS_AUTOPROLONG_DISABLED } from '../../../../../shared/constants/config';

export default () => {
  return {
    template,
    scope: {},
    bindToController: {
      publishTerms: '=',
      balance: '@',
      agencyBalance: '@',
      tariff: '@?',
      category: '@',
      isFailed: '=',
      id: '@?',
      status: '@?',
      photosCountCurrent: '@photosCount',
      businessShoppingCenterId: '=',
      newObjectId: '=',
      newObjectHouseId: '=',
      isSubAgent: '@?',
      subAgentMoneySource: '@?',
      ad: '=',
    },
    controller:
      function (
        $rootScope, $scope, $timeout, $window, geoService, pubAvailService, adStateService, jkService,
        bsCenterService, hiddenBaseService, addFormService, userService, userIdentificationService, config,
        telemetryService, publishTermsService
      ) {
        'ngInject';
        telemetryService.mark('addform.publish-terms-segment-init');

        this.geoService = geoService;
        this.photosCount = this.photosCountCurrent || '0';
        this.isFromXML = window.addFormState.isFromXML;

        // Если включена публикация в скрытую базу, не надо делать запросы к биллингу
        this.isAvailable = () =>
          pubAvailService.isAvailable &&
          !hiddenBaseService.isEnabled() &&
          this.category &&
          geoService.getLocationPath() &&
          geoService.getLocationPath().length;

        this.user = userService.user;
        this.showAgencyBalance = userService.user.showAgencyBalance;

        $scope.pubAvailService = pubAvailService;
        $scope.useCheckService = USE_CHECK_SERVICE;
        $scope.isAutoprolongDisabled = IS_AUTOPROLONG_DISABLED;
        $scope.isArchived = adStateService.isArchived;

        this.failedMessage = !this.id || this.status === 'draft'
          ? 'Сохраните ваше объявление в черновик и повторите попытку позднее.'
          : null;

        this.additionalDataToRequest = {};

        /**
         * Следим за категорией
         * - если категория БЦ, то формируем объект с ID БЦ
         * - если категория ЖК, то формируем объект с ID ЖК и ID дома в ЖК
         * - иначе формируем пустой объект
         * Знание о категории(БЦ это или ЖК) есть только в форме, для кита это не важно.
         * Кит просто получает сформированный объект и добавляет к запросам check-service, check-publish, publish-terms
         */
        $scope.$watch(() => ({
          category: this.category || null,
          businessShoppingCenterId: this.businessShoppingCenterId || null,
          newObjectId: this.newObjectId || null,
          newObjectHouseId: this.newObjectHouseId || null,
        }), () => {
          if (jkService.isJkCategory()) {
            this.additionalDataToRequest = {
              newObjectId: this.newObjectId,
              newObjectHouseId: this.newObjectHouseId
            };
          } else if (bsCenterService.isBSCategory()) {
            this.additionalDataToRequest = {
              businessShoppingCenterId: this.businessShoppingCenterId
            };
          } else {
            this.additionalDataToRequest = {};
          }
        }, true);

        const photosUpdateListener = $rootScope.$on('cianUiPhotoUpload:PHOTOS_UPDATED', () => {
          // wait for model updating
          $timeout(() => {
            this.photosCount = this.photosCountCurrent;
          }, 0);
        });

        const checkServiceBlockingActionName = 'placingTerms.checkService';
        this.onCheckServiceRequestStart = () => {
          addFormService.addBlockingAction(checkServiceBlockingActionName);
        };

        this.onCheckServiceRequestFinish = () => {
          addFormService.removeBlockingAction(checkServiceBlockingActionName);
        };

        $scope.$on('$destroy', () => {
          photosUpdateListener();
        });

        this.onPassIdentificationClick = () => {
          event.preventDefault();
          addFormService.ad.status = 'draft';
          userIdentificationService.setPostDraftSaveCallback(() => {
            // Ждем пока изменится тип аккаунта (происходит не сразу после сохранения черновика)
            setTimeout(() => {
              $window.location = 'https://my.cian.ru/identification/';
          }, config.get('addForm.identificationAfterDraftDelay'));
          });
          $rootScope.$broadcast('publishAd');
        };

        $scope.isNewPublishTermsEnabled = publishTermsService.isNewPublishTermsEnabled;
      },
    controllerAs: 'adPlacingTermsCtrl',
    replace: true,
  };
};
